import { render, staticRenderFns } from "./AdventureLeaderboard.vue?vue&type=template&id=0cfeb1d4&scoped=true&"
import script from "./AdventureLeaderboard.vue?vue&type=script&lang=ts&"
export * from "./AdventureLeaderboard.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureLeaderboard.vue?vue&type=style&index=0&id=0cfeb1d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfeb1d4",
  null
  
)

export default component.exports